import { css_manager } from './Css.js';
import { svg_manager, line_hard, shape_hard } from './Svg.js';
import { loop_type } from './Loop.js';
import { inpt_type } from './Inpt.js';
import { Locl } from './Locl.js';

const Css = css_manager();
const Svg = svg_manager();

export type dbug_type = {
    list: Map<string, HTMLElement | SVGElement>;
    id: string;
    on: boolean;
    on_toggle: ((on: boolean) => void) | null;
    toggle: (new_state?: boolean | undefined) => void;
    run: (Screen: any, ia: any[], Time: loop_type) => void;
}

export function dbug_manager(Screen: any, Inpt: inpt_type): dbug_type {

    const finger = Css.make_rect({ x: 0, y: 0, opacity: 0, parent: Screen.dom, stroke_color: "#33f", stroke: 0.002, width: 0.04, height: 0.04, shape: "circle", res: Screen.res });
    const svg_layer = Svg.make_layer({ id: "dbug", width: Screen.width, x: 0, y: 0, height: Screen.height, parent: Screen.dom, res: Screen.res }) as SVGElement;
    const fps = Css.make_rect({ id: "fps", x: Screen.x + 0.025, y: Screen.yy - 0.025, text: 60, parent: Screen.dom, text_color: "#fff", text_size: 0.015, color: "#333", width: 0.015, height: 0.01, res: Screen.res, opacity: "0" });

    document.addEventListener('touchstart', (e) => {
        if (e.touches.length === 5) debuggs.toggle();
    }, { passive: true });

    const persisted = Locl.get("dbug");
    const debuggs = {
        list: new Map<string, HTMLElement | SVGElement>(),
        id: "dbug",
        on: persisted === true,
        on_toggle: null as dbug_type["on_toggle"],
        toggle: function (new_state?: boolean) {
            if (typeof new_state === "boolean") {
                this.on = new_state;
            } else {
                this.on = !this.on;
            }
            if (!this.on) {
                for (const e of this.list.values()) {
                    e.remove();
                }
                this.list.clear();
            }
            finger.style.opacity = this.on ? "1" : "0";
            fps.style.opacity = this.on ? "1" : "0";
            Locl.set("dbug", this.on);
            this.on_toggle?.(this.on);
            console.log("Dbug", this.on);
        },
        run: function (Screen: any, ia: any[], Time: loop_type) {

            if (!this.on) return;

            finger.style.transform = "translateX(" + (Inpt.pointer.pos.x * Screen.res) + "px) translateY(" + (Inpt.pointer.pos.y * Screen.res) + "px)";

            for (const o of ia) {

                const dbg_id = o.type + "_" + o.id;

                //init dom element if not existing yet (Map keyed by composite id → O(1))
                let dom = this.list.get(dbg_id);
                if (!dom) {
                    if (o.type == "pnts") {
                        dom = Css.make_rect({ id: dbg_id, parent: Screen.dom, color: "#ff7", width: 0.004, height: 0.004, res: Screen.res }) as HTMLElement;
                    } else if (o.type == "body") {
                        dom = Svg.make_shape({ id: dbg_id, parent: svg_layer, stroke: 0.002, stroke_color: "hsl(190, 100%, 65%)", dash: "2 3", color: "transparent", res: Screen.res }) as SVGElement;
                    } else if (o.type == "hkks") {
                        dom = Css.make_rect({ id: dbg_id, parent: Screen.dom, color: "hsl(133, 100%, 73%)", width: 0.004, height: 0.004, res: Screen.res }) as HTMLElement;
                    } else if (o.type == "lnks") {
                        dom = Svg.make_line({ id: dbg_id, parent: svg_layer, stroke: 0.002, color: "hsl(19, 100%, 61%)", dash: "2 1", res: Screen.res }) as SVGElement;
                    } else if (o.type == "plls") {
                        dom = Svg.make_line({ id: dbg_id, parent: svg_layer, stroke: 0.002, color: "hsl(61, 100%, 73%)", dash: "2 6", res: Screen.res }) as SVGElement;
                    } else if (o.type == "jnts") {
                        dom = Svg.make_line({ id: dbg_id, parent: svg_layer, stroke: 0.002, color: "hsl(300, 100%, 83%)", dash: "2 2", res: Screen.res }) as SVGElement;
                    }
                    if (dom) this.list.set(dbg_id, dom);
                }
                if (!dom) continue;

                //move dom element to reference point pos
                if (o.type == "pnts" || o.type == "hkks") {
                    dom.style.transform = "translateX(" + (o.pos.x * Screen.res) + "px) translateY(" + (o.pos.y * Screen.res) + "px)";
                } else if (o.type == "lnks" || o.type == "plls") {
                    dom.setAttributeNS(null, "d", line_hard([o.a.pos, o.b.pos], Screen.res));
                } else if (o.type == "jnts") {
                    dom.setAttributeNS(null, "d", line_hard([o.a.pos, o.c.pos], Screen.res));
                } else if (o.type == "body") {
                    {
                        const cb = Math.cos(o.ang);
                        const sb = Math.sin(o.ang);
                        const corners = [
                            { x: o.pos.x + (-o.width) * cb - (-o.height) * sb, y: o.pos.y + (-o.width) * sb + (-o.height) * cb },
                            { x: o.pos.x + (o.width) * cb - (-o.height) * sb, y: o.pos.y + (o.width) * sb + (-o.height) * cb },
                            { x: o.pos.x + (o.width) * cb - (o.height) * sb, y: o.pos.y + (o.width) * sb + (o.height) * cb },
                            { x: o.pos.x + (-o.width) * cb - (o.height) * sb, y: o.pos.y + (-o.width) * sb + (o.height) * cb },
                        ];
                        dom.setAttributeNS(null, "d", shape_hard(corners, Screen.res));
                    }
                }
            }

            //in case reference element doesn't exist anymore kill dom.
            const live_ids = new Set(ia.map((o) => o.type + "_" + o.id));
            for (const [key, el] of this.list) {
                if (!live_ids.has(key)) {
                    this.list.delete(key);
                    el.remove();
                }
            }

            fps.innerHTML = String(Math.trunc(1000 / Time.delta_ms));
        }
    }

    if (debuggs.on) {
        finger.style.opacity = "1";
        fps.style.opacity = "1";
    }

    //togglers
    document.addEventListener('keydown', function (event) {
        if (event.key === 'd') debuggs.toggle();
    });
    document.addEventListener('pointerup', function () {
        finger.style.borderColor = "#33f";
    });
    document.addEventListener('pointerdown', () => {
        finger.style.borderColor = "#f00";
    });

    return debuggs;
}